import { SearchFilters } from "../../../interfaces/state/searchQuery";
import { BoundingBoxInterface } from "../types";
import { createJsonSessionStore } from "./sessionStore";

export interface SessionSearchState {
    text?: string | null;
    title?: string | null;
    placeId?: string | null;
    startDate?: string | null; // DD-MM-YYYY or null
    endDate?: string | null;   // DD-MM-YYYY or null
    searchFilters?: SearchFilters;
    boundingBox?: BoundingBoxInterface | null;
}

const store = createJsonSessionStore<SessionSearchState>('search_session');

export const getSessionSearchState = (sessionId: string): SessionSearchState | null => {
    return store.load(sessionId);
};

export const saveSessionSearchState = (sessionId: string, state: SessionSearchState): void => {
    store.save(sessionId, state);
};

// Removed per-session full history persistence; rely on backend fetch only


